const initialState = {
  contactDataList: [],
  meetingDataList: [],
  notificationDataList: [],
  mailHistoryList: [],
  employeeList: [],
  ddOptionList: [],
  auth_email_id: "",
  auth_name: "",
  auth_id: "",
  role: [],
  components_list: [],
  screen_list: [],
  dashboard_card_list: [],
  flow_type: "",
};

const contactData = (state = initialState, action) => {
  switch (action.type) {
    case "CONTACT_DATA_GET":
      return { ...state, contactDataList: action.payload };
    case "MEETING_DATA_GET":
      return { ...state, meetingDataList: action.payload };

    case "MAIL_HISTORY_GET":
      return { ...state, mailHistoryList: action.payload };
    case "EMPLOYEE_DETAILS_GET":
      return { ...state, employeeList: action.payload };
    case "DROPDOWN_OPTIONS_GET":
      return { ...state, ddOptionList: action.payload };
    case "DASHBOARD_CARD_LIST_SET":
      return { ...state, dashboard_card_list: action.payload };
    case "AUTH_DATA":
      return {
        ...state,
        auth_name: action.auth_name,
        auth_email_id: action.auth_email_id,
        auth_id: action.auth_id,
        user_token: action.user_token,
        role: action.role,
      };
    case "NOTIFICATION_DATA_GET":
      return { ...state, notificationDataList: action.payload };
    case "ROLE_DATA":
      return {
        ...state,
        components_list: action.components_list,
        screen_list: action.screen_list,
        flow_type: action.flow_type,
      };

    default:
      return state;
  }
};
export default contactData;
